module.exports = __webpack_public_path__ + "img/checked-outlined.86f44c6b.svg";